import { get } from 'lodash/fp';
import config from '../helpers/config';

export default get(config.estimatebuilderMode);

